import './style.scss';
import Heading from './heading.js';

export default Heading;